import { RootState } from './index'

export const selectProfileSessionState = (rootState: RootState) =>
  rootState.profileSession
